import Avatar from './Avatar.jsx';
import MedalGlyph from './MedalGlyph.jsx';
import s from './LeaderboardRow.module.css';

export default function LeaderboardRow({ rank, avatarSrc, athleteInitials, athleteName, weight, ...rest }) {
  const rankClass =
    rank === 1 ? s.gold :
    rank === 2 ? s.silver :
    rank === 3 ? s.bronze : '';
  const medalRank = rank === 1 ? 'gold' : rank === 2 ? 'silver' : rank === 3 ? 'bronze' : null;
  return (
    <div className={s.row} {...rest}>
      <span className={`${s.rank} ${rankClass}`}>{rank}</span>
      <Avatar src={avatarSrc} initials={athleteInitials} size="md" />
      <span className={s.name}>{athleteName}</span>
      <span className={s.weight}>{weight}</span>
      <span className={s.medal}>
        {medalRank ? <MedalGlyph name="rank" rank={medalRank} size="md" /> : null}
      </span>
    </div>
  );
}
